export const config = {
  env: import.meta.env.VITE_ENV,
  baseURL: import.meta.env.VITE_API_BASE_URL,
  googleLoginClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
};
